<template>
  <div>
    <div class="level">
      <h2 class="level-left">
        {{ "charts.itemCoverageChart.itemDetailTotals" | t }}
      </h2>
      <VsMonthPicker
        v-if="selectedDate"
        :selectedGlobalDate="selectedDate"
        class="level-right"
        @new-month-date="setNewMonthDate"
      />
    </div>
    <div v-if="isAvailableMonth">
      <div class="item-coverage">
        <Panel :panelAttr="panelAttr" :panelData="itemPanelData" />
        <ItemCoverageChartWrapper :itemCoverageTotals="itemTotals" />
      </div>
      <div class="items-updated">
        <TabsAndTable
          :tabTotals="itemMonthlyTotals"
          :selectedDate="selectedDate"
          :itemDetails="itemDetails"
          :downloadLink="downloadLink"
        />
      </div>
    </div>
    <VsNoChartData v-else height="350px">
      <template v-slot:header>
        <h2>{{ "charts.errorMessage.coverageError1" | t }}</h2>
      </template>
      <template v-slot:errorMessage>
        <p>{{ errorMessage | t }}</p>
      </template>
    </VsNoChartData>
  </div>
</template>

<script>
import Panel from "../top/Panel";
import TabsAndTable from "./itemsUpdated/Index";
import ItemCoverageChartWrapper from "./chart/Index";
import { subMonths } from "date-fns";
import { TM_PANEL_DEFINITION } from "@/misc/desktopCharts";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Panel,
    ItemCoverageChartWrapper,
    TabsAndTable,
  },
  data() {
    return {
      panelAttr: TM_PANEL_DEFINITION,
    };
  },
  computed: {
    ...mapGetters({
      itemTotals: "coverage/getItemTotals",
      itemMonthlyTotals: "coverage/getItemMonthlyTotals",
      itemDetails: "coverage/getItemDetails",
      selectedDate: "coverage/getItemDate",
      download: "coverage/getDownloadItems",
    }),
    isAvailableMonth() {
      // only available from 1st March 2019
      return this.selectedDate >= new Date(2019, 2, 1) && !this.itemPanelData.isError;
    },
    itemPanelData() {
      return { ...this.itemTotals, total: this.itemTotals["total-percentage"] };
    },
    downloadLink() {
      return this.download["url"];
    },
    errorMessage() {
      // before 1st March 2019
      if (this.selectedDate < new Date(2019, 2, 1)) {
        return "charts.errorMessage.coverageError2";
      }
      if (this.itemPanelData.isError) {
        return "charts.errorMessage.coverageError3";
      }
      return "";
    },
  },
  created() {
    if (!this.selectedDate) {
      const date = subMonths(new Date(), 1);
      this.setItemCoverageMonthDate(date);
    }
  },
  methods: {
    ...mapActions("coverage", ["setItemCoverageMonthDate"]),
    setNewMonthDate(date) {
      this.setItemCoverageMonthDate(date);
    },
  },
};
</script>

<style lang="scss" scoped>
.level {
  margin-top: 40px;
}

.item-coverage {
  margin: 10px auto 40px;
  border: $border-base;
  border-radius: $border-radius;
  background: $white;
}
</style>
